import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import {
  TopSubmit,
  BottomSubmit,
  SubmitContainer,
} from '../../../AdminRoutes/CreateRoutes/CreateForm.styles';
import Auth from '../../../Helpers/auth';
import { httpAddUserCertficate } from '../../../Hooks/user/user.post.hooks';

const HandleUploadCertificate = ({ newCertificate, setNewCertificate }) => {
  const [status, setStatus] = useState('');
  const { data } = Auth.getProfile();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Uploading Certificate...');
    const formData = new FormData();
    formData.append('userId', data._id);
    formData.append('courseName', newCertificate.courseName);
    formData.append('dateTaken', newCertificate.dateTaken);
    formData.append('expiryDate', newCertificate.expiryDate);
    formData.append('certificateFile', newCertificate.certificateFile);
    try {
      const response = await httpAddUserCertficate(formData);
      const result = await response.json();
      console.log('Certificate uploaded successfully:', result);
      // Reset the form after successful upload
      setNewCertificate({
        courseName: '',
        certificateFile: null,
        dateTaken: '',
        expiryDate: '',
      });
      setStatus('Certificate uploaded successfully');
    } catch (error) {
      setStatus('Error uploading the certifiacate');
      console.error('Error uploading certificate:', error);
      // Handle error appropriately, e.g., show a notification
    }
  };
  return (
    <SubmitContainer>
      <TopSubmit>{status && <p>{status}</p>}</TopSubmit>
      <BottomSubmit>
        <PrimaryButtonComponent
          functionName={handleSubmit}
          span="Upload Certificate"
        />
      </BottomSubmit>
    </SubmitContainer>
  );
};
HandleUploadCertificate.propTypes = {
  newCertificate: PropTypes.shape({
    courseName: PropTypes.string,
    certificateFile: PropTypes.instanceOf(File),
    dateTaken: PropTypes.string,
    expiryDate: PropTypes.string,
  }),
  setNewCertificate: PropTypes.func,
};
export default HandleUploadCertificate;
